export default __webpack_public_path__ + "static/media/interest.ef1608c9.jpg";